import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordGate() {
  const { user, setUser } = useAuth();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user?.must_change_password) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 8) return toast.error("La nuova password deve avere almeno 8 caratteri");
    if (newPw !== confirmPw) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      setUser({ ...user, must_change_password: false });
      toast.success("Password aggiornata con successo");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full bg-[#0A1826] border border-white/10 rounded-sm px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-1 focus:ring-[#EA7B2B]";

  return (
    <div className="fixed inset-0 z-[100] bg-[#0A1826]/95 backdrop-blur-sm flex items-center justify-center p-4" data-testid="change-password-gate">
      <div className="w-full max-w-md bg-[#122A3F] border border-[#EA7B2B]/40 rounded-sm p-7">
        <div className="flex items-center gap-3 mb-2">
          <ShieldAlert className="w-6 h-6 text-[#EA7B2B]" />
          <h2 className="text-xl font-light text-white">Cambio password obbligatorio</h2>
        </div>
        <p className="text-sm text-zinc-400 mb-5">Per motivi di sicurezza devi impostare una nuova password prima di continuare.</p>
        <form onSubmit={submit} className="space-y-3">
          <input type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} placeholder="Password attuale" data-testid="cpw-old" className={inputCls} required />
          <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} placeholder="Nuova password (min 8 caratteri)" data-testid="cpw-new" className={inputCls} required />
          <input type="password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} placeholder="Conferma nuova password" data-testid="cpw-confirm" className={inputCls} required />
          <button type="submit" disabled={busy} data-testid="cpw-submit" className="w-full flex items-center justify-center gap-2 bg-[#EA7B2B] text-black text-sm font-medium py-2.5 rounded-sm hover:bg-[#F59E4A] transition-colors disabled:opacity-50">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Aggiorna password
          </button>
        </form>
      </div>
    </div>
  );
}
